/* This hook does not set any states, so there will be no rerenders.
 * it uses the offsetHeight/Width of the element, so the element should
 * have box-sizing: border-box. (what we normally do, just be sure). */
import { useCallback, useRef, } from 'react';
export function useElementResizer(_a) {
    var resizableElementRef = _a.resizableElementRef, direction = _a.direction;
    var mouseStartRef = useRef(null);
    var startHandler = useCallback(function (event) {
        event.preventDefault();
        var el = resizableElementRef.current;
        if (!el) {
            // eslint-disable-next-line no-console
            console.error('resizableElementRef is null');
            return;
        }
        var pos = getXYPos(event);
        mouseStartRef.current = {
            x: pos.x,
            y: pos.y,
            width: el.offsetWidth,
            height: el.offsetHeight,
        };
        var touch = isTouchEvent(event);
        document.addEventListener(touch ? 'touchmove' : 'mousemove', moveHandler);
        document.addEventListener(touch ? 'touchend' : 'mouseup', endHandler);
    }, []);
    var moveHandler = useCallback(function (event) {
        event.preventDefault();
        var el = resizableElementRef.current;
        if (mouseStartRef.current === null || !el) {
            return;
        }
        var pos = getXYPos(event);
        var styles = {};
        if (direction === 'horizontal' || direction === 'both') {
            var width = mouseStartRef.current.width + pos.x - mouseStartRef.current.x;
            styles.width = width + 'px';
        }
        if (direction === 'vertical' || direction === 'both') {
            var height = mouseStartRef.current.height + pos.y - mouseStartRef.current.y;
            styles.height = height + 'px';
        }
        Object.assign(el.style, styles);
    }, []);
    var endHandler = useCallback(function (event) {
        event.preventDefault();
        mouseStartRef.current = null;
        document.removeEventListener('mousemove', moveHandler);
        document.removeEventListener('mouseup', endHandler);
        document.removeEventListener('touchmove', moveHandler);
        document.removeEventListener('touchend', endHandler);
    }, []);
    var resizeHandleProps = {
        onMouseDown: startHandler,
        onTouchStart: startHandler,
    };
    return {
        resizeHandleProps: resizeHandleProps,
    };
}
function isTouchEvent(event) {
    return event.type.startsWith('touch');
}
function getXYPos(event) {
    return isTouchEvent(event)
        ? { x: event.touches[0].clientX, y: event.touches[0].clientY }
        : { x: event.clientX, y: event.clientY };
}
//# sourceMappingURL=useElementResizer.js.map